<!--Page Liste des audits-->
<template>
	<dashboard-main-layout>
		<!-- Tableau -->
		<div class="pa-4">
			<v-card v-if="installations !== undefined && installations.length > 0" elevation="0">
				<v-card-title>
					<v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('_recherche_')" single-line
						hide-details></v-text-field>
				</v-card-title>
			</v-card>

			<v-data-table :headers="selectedColumnsOrdered" :items="installations" :loading="loading" item-key="id"
				:footer-props="{
					'items-per-page-options': [20, 50, 100, -1]
				}" :items-per-page="20" id="level-1-table" :search="search" :mobile-breakpoint="0"
				v-if="installationsShowable && installations">
				<template v-slot:body="{ items }">
					<tbody>
						<tr v-for="(item) in items" :key="item.id" :class="{ 'disabled': item.is_forbidden }">
							<td v-for="column in selectedColumnsOrdered" :key="column.key"
								:style="isFirstColumnOfGroup(column) ? 'border-left:1px solid lightgray; cursor: pointer' : 'cursor: pointer'"
								@click="goToInstallation(item, column.key)">
								<installation-field :column="column.key" :item="item"
									v-if="column.key !== undefined && column.key !== 'actions' && column.key !== 'rapport'" />
							</td>
						</tr>
					</tbody>
				</template>
			</v-data-table>
		</div>
	</dashboard-main-layout>
</template>

<script>
// Components
import DashboardMainLayout from "../../layouts/Dashboard/MainLayout";
import InstallationField from "../../components/Table/InstallationFieldTech";
// import AppbarBordered from "../../components/Utils/AppbarBordered";
import backend from '@/api/backend';
import { mapMutations } from "vuex";
import api from "../../api/api";
import { mapGetters } from "vuex";
import webconf from "../../utils/frontend_setup"


export default {
	components: {
		DashboardMainLayout,
		// AppbarBordered,
		InstallationField,
	},

	data() {
		return {

			// script_name: "Main.vue (Dashboard Niv1)",        // For debug
			loading: false,
			target_menu: "",
			hoverInstallation: false,
			selectedColumns: [],
			selectedColumnsOrdered: [],
			valMan: ["installation_name", "company_name"],
			showReportLink: false,
			showSelectionGroup: false,
			// showInstallationOtherColumnsMenu: false,
			search: "",
			alarms: [],
			alarms_per_id: {},
			installations: null,
			// sortedInstallations:[]
		};
	},

	watch: {
		'$route': {
			handler() {
				this.$store.commit("SET_CUR_INSTALL_ID", null)
			},
			immediate: true,
			deep: true,
		},
	},

	async created() {
		let installs = this.$store.getters.installations
		for (let index in installs){
			const installIdActu = installs[index].installation_id
			try {
				const res = (await backend.get_alarmquery_install(installIdActu)).data
				for (let alarmId in res){
					this.alarms.push(res[alarmId])
				}
				this.alarms_per_id[installIdActu] = res.length
			}
			catch {
				console.log("Pas d'alarme pour l'installation", installIdActu)
			}
			if (this.alarms_per_id[installIdActu] !== undefined)
						installs[index].nb_alarm = this.alarms_per_id[installs[index].id]
			
		}
		await (this.$nextTick())
		this.installations= this.sort(installs)
	},

	computed: {
		...mapGetters(["cur_install_id"]),

		constants() {
			webconf.debugLog('computed', this.script_name, 'constants',
				this.$store.getters.constants
			)
			return this.$store.getters.constants;
		},

		installationsShowable() {
			return this.installations
				&& Array.isArray(this.installations)
				&& this.selectedColumnsOrdered
				&& this.selectedColumnsOrdered.length
		},

		unselectedColumns() {
			return this.constants.columns.filter(
				(x) => !this.selectedColumns.includes(x)
			);
		},


		dates() {
			webconf.debugLog('computed', this.script_name, 'constants',
				this.$store.state.parametersStore.dates
			)
			return this.$store.state.parametersStore.dates;
		},
	},

	methods: {
		sort(installation) {
			return [...installation].sort((a, b) => {
				if (a.nb_alarm === undefined)
					return 1
				if (b.nb_alarm == undefined)
					return -1
				return b.nb_alarm - a.nb_alarm;
			});
		},

		async getPDF(repoId) {
			await api
				.getPDFUrl(repoId)
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'file.pdf');
					document.body.appendChild(link);
					link.click();
				}).catch(console.error)
		},

		getColumns(group) {
			// Catch column group

			return this.constants.columns.filter((column) =>
				column.group === group && column.show_dashboard.includes(this.target_menu)
			);
		},

		isFirstColumnOfGroup(column) {
			if (column.key === "action_list") return true;
			const group = column.group;
			const columns = this.getColumns(group);
			return !columns.indexOf(column);
		},

		goToInstallation(installation) {

			this.$store.dispatch("setInstallationAuditDate", {
				start_date: installation.audit_start_date,
				end_date: installation.audit_end_date
			});

			this.$store.dispatch("setInstallationMaxDates", {
				start_date: installation.audit_start_date,
				end_date: installation.audit_end_date
			});

			this.$store.dispatch("setShowDateSelector", { show: true });
			this.$store.commit("SET_EXPERT_PDM", this.current_pdm);

			this.$store.commit("SET_GEO_PDM", '');

			this.$store.commit("SET_CUR_INSTALL_ID", installation.id);
			const path = `/tech/map/${installation.id}`;
			if (this.$route.path !== path) this.$router.push(path);
		},

		getInstallationList() {
			this.loading = true

			return this.$store
				// .dispatch("getInstallationList", {'analysis_mode': this.analysis_mode})
				.dispatch("getInstallationList")
				.then(async () => {
					this.loading = false;
					this.selectedColumns = this.constants.columns.filter((column) =>
						column.show_dashboard.includes(this.target_menu)
					);
				});
		},

		...mapMutations(["SET_INSTALLATIONS", "SET_SHOW_DATE_SELECTOR"]),
	},

	async mounted() {
		if (this.constants.columns)
			this.selectedColumns =
				this.constants.columns.filter((column) =>
					this.valMan.includes(column.key)
				);

		if (!this.selectedColumns || !this.selectedColumns.length) return []
		else {
			this.selectedColumnsOrdered = this.$_.orderBy(this.selectedColumns, ['index'], ['asc']).map(c => {
				return {
					...c,
					...{
						text: this.$t(c.text),
						value: c.key
					}
				}
			})
		}

		this.target_menu = (this.$route.name === 'dashboard-audits') ? 'audit' : 'continuous'
		this.getInstallationList()

		
	}

};
</script>

<style>
.theme--light.v-data-table>.v-data-table__wrapper,
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr {
	border-radius: 5px;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr {
	background-color: rgb(214, 214, 214);
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
	color: #504F4F;
	padding-top: 10px;
	padding-bottom: 10px;
}

.theme--light.v-data-table .v-data-table-header th.sortable:hover,
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable.active {
	color: #000000;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.theme--light.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
	font-size: .775rem;
	height: 55px;
}

.disabled {
	background-color: lightgray;
	pointer-events: none;
}
</style>
